const HAS_ZONE = /(?:Z|[+-]\d{2}:?\d{2})$/i;

const toEpochMs = (seenAt: string): number => Date.parse(HAS_ZONE.test(seenAt) ? seenAt : `${seenAt}Z`);

export const formatSeenDate = (seenAt: string): string =>
    new Date(toEpochMs(seenAt)).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
